import React from "react";
import {BrandName} from "../../../constants";
import {ListItem, Paragraph} from "../TermsText";

const ParticipationConductSection = () => {
  return (
    <>
      <Paragraph>
        {"In addition, conduct that would be deemed improper also includes, but is not limited to:"}
      </Paragraph>

      <ListItem>{"Falsifying personal information required to enter a Challenge or claim a prize;"}</ListItem>

      <ListItem>
        {"Engaging in any type of financial fraud including unauthorized use of credit instruments to enter a Challenge or claim a prize;"}
      </ListItem>

      <ListItem>{"Colluding with any other individual(s) or engaging in any type of syndicate play;"}</ListItem>

      <ListItem>{"Any violation of Challenge rules or the Terms of Use;"}</ListItem>

      <ListItem>
        {"Using a single Account to participate in a Challenge on behalf of multiple entrants or otherwise collaborating with others to participate in any Challenge;"}
      </ListItem>

      <ListItem>
        {"Using automated means (including but not limited to scripts and third-party tools) to interact with the Website in any way (this includes, but is not limited to: creating a challenge, entering a challenge, withdrawing from a challenge, creating a lineup, and editing a lineup);"}
      </ListItem>

      <ListItem>
        {"Using automated means (including but not limited to harvesting bots, robots, parser, spiders or screen scrapers) to obtain, collect or access any information on the Website or of any User for any purpose."}
      </ListItem>

      <ListItem>
        {"Any type of bonus abuse, abuse of the refer-a-friend program, or abuse of any other offers or promotions;"}
      </ListItem>

      <ListItem>
        {"Tampering with the administration of a Challenge or trying to in any way tamper with the computer programs or any security measure associated with a Challenge;"}
      </ListItem>

      <ListItem>{"Obtaining other entrants information and spamming other entrants; or"}</ListItem>

      <ListItem>{"Abusing the Website, Applications, or other interface in any way."}</ListItem>

      <ListItem>
        {"Users further acknowledge that the forfeiture and/or return of any prize shall in no way prevent "}{BrandName}{" from pursuing criminal or civil proceedings in connection with such conduct."}
      </ListItem>

      <ListItem>
        {"By entering into a Challenge or accepting any prize, entrants, including but not limited to the winner(s), agree to indemnify, release and to hold harmless "}{BrandName}{", its parents, subsidiaries, affiliates and agents, as well as the officers, directors, employees, shareholders and representatives of any of the foregoing entities (collectively, the \"Released Parties\"), from any and all liability, claims or actions of any kind whatsoever, including but not limited to injuries, damages, or losses to persons and property which may be sustained in connection with participation in the Challenge, the receipt, ownership, use or misuse of any prize or while preparing for, participating in and/or travelling to or from any prize related activity, as well as any claims based on publicity rights, defamation, or invasion of privacy. "}{BrandName}{" may, in its sole and absolute discretion, require an Authorized Account Holder to execute a separate release of claims similar to the one listed above in this Paragraph as a condition of being awarded any prize or receiving any payout."}
      </ListItem>

      <ListItem mb={15}>
        {BrandName}{" is not responsible for: any incorrect, invalid or inaccurate entry information; human errors; postal delays/postage due mail; technical malfunctions; failures, including public utility or telephone outages; omissions, interruptions, deletions or defects of any telephone system or network, computer online systems, data, computer equipment, servers, providers, or software (including, but not limited to software and operating systems that do not permit an entrant to participate in a Challenge), including without limitation any injury or damage to any entrant's or any other person's computer or video equipment relating to or resulting from participation in a Challenge; inability to access the Website, or any web pages that are part of or related to the Website; theft, tampering, destruction, or unauthorized access to, or alteration of, entries and/or images of any kind; data that is processed late or incorrectly or is incomplete or lost due to telephone, postal issues, computer or electronic malfunction or traffic congestion on telephone lines or transmission systems, or the Internet, or any service provider's facilities, or any phone site or website or for any other reason whatsoever; typographical, printing or other errors, or any combination thereof."}
      </ListItem>
    </>
  );
};

export default React.memo(ParticipationConductSection);
